import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '../assets/logo.png'
import _imports_1 from '../../public/google.png'
import _imports_2 from '../../public/sm_facebook.png'
import _imports_3 from '../../public/apple.png'


const _hoisted_1 = { style: { display: 'flex', justifyContent: 'end', margin: '20px' } }
const _hoisted_2 = { class: "styleDiv" }
const _hoisted_3 = {
  key: 0,
  class: "loader-container"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { style: {"text-align":"center","margin":"20px","font-size":"22px","color":"#6d2144","font-weight":"600","font-family":"sans-serif","letter-spacing":"0.3px"} }
const _hoisted_6 = { class: "mainDiv" }
const _hoisted_7 = { class: "subDiv" }
const _hoisted_8 = { style: { margin: '0px 5px' } }
const _hoisted_9 = { class: "socialMediaLogoContainer" }
const _hoisted_10 = {
  type: "button",
  class: "button_container"
}

import { loginApi, LoginWithAppleAPI, LoginWithGoogleAPI, loginWithFacebookAPI, getLanguageList } from "@/services/api/auth";
import { UnwrapRef, reactive, ref } from "vue";
import { openNotificationWithIcon } from "../utils/index";
import router from "@/router";
import { jwtDecode } from "jwt-decode";
import { APPLE_CLIENT_ID, APPLE_REDIRECT_URI } from "../.config";
import LanguageDropdown from "@/components/LanguageDropdown.vue";

interface FormState {
	email: string;
	password: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

localStorage.removeItem("user");

const loading = ref(false);
const formState: UnwrapRef<FormState> = reactive({
	email: "",
	password: "",
});
const device_language = navigator.language.replace("-", "_");
// const language = ref(device_language === "pt_BR" ? "PT" : "EN");
let language = ref("EN");
if (device_language === "pt_BR") {
	language.value = "PT";
} else if (device_language.toLowerCase() === "is_is" || device_language.toLowerCase() === "is" || device_language.startsWith("is")) {
	language.value = "IS";
}

const languageList = ref<any[]>([]);
const translate = ref<any[]>([]);

const handleLanguageChange = async (lang: string) => {
	language.value = lang;
	localStorage.setItem('lang_for_delete', lang);
};

const fetchLanguages = async () => {
	try {
		loading.value = true;
		const key = '78 - Delete UI';
		const res = await Promise.all([
			getLanguageList(key),
			getLanguageList('25 - My Settings'),
		]).then(([deleteUiTranslationList, deleteLanguageTranslationList]) => ({
			...deleteUiTranslationList,
			translate: [
				...(deleteUiTranslationList.translate || []),
				...(deleteLanguageTranslationList.translate || []),
			],
		}));

		languageList.value = res.languageList.length
			? res.languageList.filter((lang: any) => lang.key === "EN" || lang.key === "PT" || lang.key === "IS" || lang.key === "is_IS")
			: [];
		translate.value = res.translate || [];

		const deletePageKeys = ["del_ui_del_btn_delete_account", "del_ui_del_page_intro_1", "del_ui_del_page_intro_2", "del_ui_del_page_intro_3", "del_ui_del_btn_cancel", "del_ui_del_page_heading", 'del_ui_del_model_info', 'del_ui_account_delete_msg', 'del_ui_network_error', 'del_ui_user_not_exist', 'del_ui_support_team_msg', 'del_ui_del_model_del_btn', 'accDelete_btn_continue', 'accDelete_title_helpUs', 'accDelete_txt_yourFeedback', 'accDelete_q_1', 'accDelete_q_2', 'accDelete_q_3', 'accDelete_q_4', 'accDelete_q_5', 'accDelete_q_6', 'accDelete_q_Last', 'accDelete_alert_enterReason', 'accDelete_title_feedback', 'accDelete_feedb_sad', 'accDelete_feedb_better', 'accDelete_inTxt_feedback', "accDelete_btn_continue", "accDelete_inTxt_yourReason"];

		const deletePageTranslations = translate.value.filter((item: any) =>
			deletePageKeys.includes(item.key)
		);

		localStorage.setItem('lang_for_delete', language.value);
		localStorage.setItem(
			"delete_page_translate",
			JSON.stringify({ deletePageTranslations, languageList: languageList.value, })
		);
		loading.value = false;
	} catch (err: any) {
		loading.value = false;
		console.error("Failed to fetch language list:", err.message || err);
	}
};

fetchLanguages();


const translateText = (key: string, params: Record<string, string> = {}): string => {
	if (!translate.value || !Array.isArray(translate.value)) return key;

	const translationItem = translate.value.find((item) => item.key === key);
	if (!translationItem) return key;

	const userLangLower = language.value?.toLowerCase();
	const selectedLang = languageList.value.find(
		(lang) => lang.key?.toLowerCase() === userLangLower
	);
	const selectedLangId = selectedLang?._id;

	let translation: any;

	if (selectedLangId) {
		translation = translationItem.translate.find(
			(t: any) => t.languageId === selectedLangId && t.isPublished
		)?.value;
	}

	if (!translation) {
		const enLang = languageList.value.find((lang) => lang.key?.toLowerCase() === "en");
		const enLangId = enLang?._id;
		if (enLangId) {
			translation = translationItem.translate.find(
				(t: any) => t.languageId === enLangId && t.isPublished
			)?.value;
		}
	}

	if (!translation) translation = translationItem.base;

	if (translation && params) {
		Object.keys(params).forEach((k) => {
			const regex = new RegExp(`%this\\.user\\.${k}%`, "g");
			translation = translation.replace(regex, params[k]);
		});
	}

	return translation;
};

const onSubmit = async () => {
	try {
		const trimmedEmail = formState.email.trim();

		if (!trimmedEmail) {
			return openNotificationWithIcon("warning", translateText('del_ui_login_email_validation_text'));
		}

		// Validate email format using a simple regex pattern
		const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		if (!emailPattern.test(trimmedEmail)) {
			return openNotificationWithIcon("warning", translateText("del_ui_email_validate"));
		}

		// Update formState.email with the trimmed value
		formState.email = trimmedEmail;

		// Trim password before validation
		const trimmedPassword = formState.password.trim();

		if (!trimmedPassword) {
			return openNotificationWithIcon("warning", translateText('del_ui_login_password_validation_text'));
		}

		// Password should have a minimum length (e.g., 6 characters)
		if (trimmedPassword.length < 6) {
			return openNotificationWithIcon("warning", translateText('del_ui_password_validate'));
		}

		// Update formState.password with the trimmed value
		formState.password = trimmedPassword;

		const apiRes: any = await loginApi(formState);
		if (!apiRes) {
			return openNotificationWithIcon("error", translateText('del_ui_invalid_email_pass_text'));
		}

		if (apiRes.msg?.includes("You logged in via")) {
			const msg = apiRes.msg;
			if (/facebook/i.test(msg)) {
				return openNotificationWithIcon("warning", translateText("del_ui_facebook_social_account_text"));
			} else if (/google/i.test(msg)) {
				return openNotificationWithIcon("warning", translateText("del_ui_google_social_account_text"));
			} else if (/apple/i.test(msg)) {
				return openNotificationWithIcon("warning", translateText("del_ui_apple_social_account_text"));
			}
			return openNotificationWithIcon("warning", msg);
		}

		if (apiRes.msg && !apiRes.valid) {
			if (apiRes.key === 'not-found') {
				return openNotificationWithIcon("warning", translateText('del_ui_user_not_found'));
			}
			else if (apiRes.msg?.includes("Invalid password")) {
				return openNotificationWithIcon("warning", translateText('del_ui_invalid_pass_text'));
			}
			else {
				return openNotificationWithIcon("warning", apiRes.msg);
			}
		}

		if (!apiRes.roles || !apiRes.roles.includes("active")) {
			return openNotificationWithIcon("warning", translateText('del_ui_access_msg'));
		}

		apiRes.adminLoginTime = new Date().getTime();
		localStorage.setItem("user", JSON.stringify(apiRes));
		openNotificationWithIcon("success", translateText('del_ui_login_success_text'));
		router.push("/delete-account");
	} catch (error: any) {
		if (!error?.response && error?.message === "Network Error") {
			return openNotificationWithIcon("error", translateText("del_ui_network_error"));
		}

		const serverResponse = error?.response?.data;
		const msg = serverResponse?.msg || error?.response?.data?.msg;

		if (msg?.includes("You logged in via")) {
			if (/facebook/i.test(msg)) {
				return openNotificationWithIcon("warning", translateText("del_ui_facebook_social_account_text"));
			}
			if (/google/i.test(msg)) {
				return openNotificationWithIcon("warning", translateText("del_ui_google_social_account_text"));
			}
			if (/apple/i.test(msg)) {
				return openNotificationWithIcon("warning", translateText("del_ui_apple_social_account_text"));
			}
			return openNotificationWithIcon("warning", msg);
		}

		return openNotificationWithIcon("error", translateText("del_ui_server_response_text"));
	}

};

const loginWithFacebook = () => {
	window.FB.login(
		(response: any) => {
			if (response.authResponse) {
				window.FB.api("/me", { fields: "name,email" }, async (response: any) => {
					try {
						const apiRes: any = await loginWithFacebookAPI({
							identifier: response.email,
							socialId: response.id,
						});

						if (apiRes && apiRes.success && apiRes.user) {
							localStorage.setItem("user", JSON.stringify(apiRes.user));
							openNotificationWithIcon("success", translateText('del_ui_login_success_text'));
							router.push("/delete-account");
						}
					} catch (error: any) {
						console.error("Error in login:", error);
					}
				});
			}
		},
		{ scope: "public_profile,email" }
	);
};

const loginWithGoogle = async (response: any) => {
	try {
		const code = response.code;
		if (!code) {
			console.error("No authorization code returned");
			return;
		}
		const currentUrl = window.location.origin;
		const apiRes: any = await LoginWithGoogleAPI({
			code: code,
			baseurl: currentUrl,
		});
		if (apiRes && apiRes.success && apiRes.user) {
			localStorage.setItem("user", JSON.stringify(apiRes.user));
			openNotificationWithIcon("success", translateText('del_ui_login_success_text'));
			router.push("/delete-account");
		} else {
			openNotificationWithIcon("error", translateText('del_ui_user_not_found'));
		}
	} catch (error) {
		console.error("Error during Google login:", error);
		openNotificationWithIcon("error", translateText('del_ui_error_msg_text'));
	}
};

const loginWithApple = async () => {
	try {
		window.AppleID.auth.init({
			clientId: APPLE_CLIENT_ID,
			scope: "name email",
			redirectURI: APPLE_REDIRECT_URI,
			usePopup: true,
		});
		const response = await window.AppleID.auth.signIn();
		const {
			authorization: { id_token },
		} = response;

		const decoded: any = jwtDecode(id_token);
		const email = decoded.email;
		const socialId = decoded.sub;
		const apiRes = await LoginWithAppleAPI({
			identifier: email,
			socialId: socialId,
		});

		if (apiRes && apiRes.success && apiRes.user) {
			localStorage.setItem("user", JSON.stringify(apiRes.user));
			openNotificationWithIcon("success", translateText('del_ui_login_success_text'));
			router.push("/delete-account");
		} else {
			openNotificationWithIcon("error", translateText('del_ui_login_failed'));
		}
	} catch (error) {
		console.error("Apple Login Error", error);
	}
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_GoogleLogin = _resolveComponent("GoogleLogin")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(LanguageDropdown, {
        languageList: languageList.value,
        defaultLang: _unref(language),
        onLanguageChanged: handleLanguageChange
      }, null, 8, ["languageList", "defaultLang"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("div", { class: "simple-spinner" }, null, -1)
          ]))]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_a_form, {
              model: formState,
              class: "form"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _cache[3] || (_cache[3] = _createElementVNode("img", {
                    src: _imports_0,
                    alt: "Vue logo",
                    class: "image"
                  }, null, -1)),
                  _createElementVNode("div", _hoisted_5, _toDisplayString(translateText('del_ui_login_heading_text')), 1)
                ]),
                _createVNode(_component_a_form_item, { class: "formItem" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      class: "input",
                      value: formState.email,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formState.email) = $event)),
                      placeholder: translateText('del_ui_input_email_text')
                    }, null, 8, ["value", "placeholder"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  class: "formItem",
                  name: "password"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_password, {
                      value: formState.password,
                      "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formState.password) = $event)),
                      class: "input",
                      placeholder: translateText('del_ui_pass_input_text')
                    }, null, 8, ["value", "placeholder"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_button, {
                  type: "primary",
                  size: "large",
                  class: "btn",
                  onClick: onSubmit
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(translateText('del_ui_login_btn_text')), 1)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(translateText('del_ui_signin_option_text')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", null, [
                      _createElementVNode("button", _hoisted_10, [
                        _createVNode(_component_GoogleLogin, { callback: loginWithGoogle }, {
                          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                            _createElementVNode("img", {
                              src: _imports_1,
                              alt: "Login with google",
                              style: {"width":"46px","height":"46px"}
                            }, null, -1)
                          ]))]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        onClick: loginWithFacebook,
                        type: "button",
                        class: "button_container"
                      }, [...(_cache[5] || (_cache[5] = [
                        _createElementVNode("img", {
                          src: _imports_2,
                          alt: "Login with Facebook",
                          style: {"width":"46px","height":"46px"}
                        }, null, -1)
                      ]))])
                    ]),
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        onClick: loginWithApple,
                        type: "button",
                        class: "button_container"
                      }, [...(_cache[6] || (_cache[6] = [
                        _createElementVNode("img", {
                          src: _imports_3,
                          alt: "Login with Apple",
                          style: {"width":"46px","height":"46px"}
                        }, null, -1)
                      ]))])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["model"])
          ]))
    ])
  ], 64))
}
}

})